export default __webpack_public_path__ + "static/media/mockUnit.7b04231d.png";